export default function scrollToIframe() {

	window.parent.postMessage(
		{
			func: "scrollToIframe",
		},
		"*"
	);
}
